import React, { useState, useEffect } from 'react';
import {
  getCompany,
  getPlaidLink,
  getBankAccounts,
  getAmazonSellerAccounts,
} from '../../components/API';
import { Theme, makeStyles } from '@material-ui/core';
import { getUserAttributes, is8DataApp } from '../../utils';
import LoadingBackdrop from '../../components/LoadingBackdrop';
import Header from '../../components/BuildingBlocks/Misc/Header_v2';
import SubHeader from '../../components/BuildingBlocks/Misc/SubHeader';
import PageContent from '../../components/BuildingBlocks/Misc/PageContent';
import Layout from '../../components/Account/Layout';

const useStyles = makeStyles((theme: Theme) => ({
  centerizedContent: {
    maxWidth: theme.spacing(160),
    marginRight: 'auto',
    marginLeft: 'auto',
  },
}));

const HEADER_8FIG =
  'Connect your bank account, sync your Amazon Seller data, and manage your personal information.';
const HEADER_8DATA = 'Manage your personal information.';

export default function Account() {
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState(null);
  const [company, setCompany] = useState(null);
  const [bankAccounts, setBankAccounts] = useState(null);
  const [plaidLinkToken, setPlaidLinkToken] = useState(null);
  const [amzAccounts, setAmzAccounts] = useState(null);
  const classes = useStyles();

  async function getUser() {
    const user = await getUserAttributes();
    setUser(user);
  }

  async function getCompanyWrapper() {
    try {
      const company = await getCompany();
      setCompany(company);
    } catch {
      setCompany({
        name: null,
        numEmployees: null,
        monthlyRevenue: null,
        established: null,
        numProductsSold: null,
        storeUrl: null,
      });
    }
  }

  async function getBankAccountsWrapper() {
    try {
      const banks = await getBankAccounts();
      setBankAccounts(banks);
    } catch (error) {
      setBankAccounts([]);
    }
  }

  async function getPlaidLinkTokenWrapper() {
    try {
      const plaidToken = await getPlaidLink();
      setPlaidLinkToken(plaidToken.link_token);
      localStorage.setItem('plaidToken', plaidToken.link_token);
    } catch (error) {
      setPlaidLinkToken('error');
    }
  }

  async function getAmazonSellerAccountsWrapper() {
    try {
      const amzAccounts = await getAmazonSellerAccounts();
      setAmzAccounts(amzAccounts);
    } catch (error) {
      setAmzAccounts([]);
    }
  }

  async function getAccountData() {
    setLoading(true);
    await Promise.all([
      getUser(),
      getCompanyWrapper(),
      getBankAccountsWrapper(),
      getPlaidLinkTokenWrapper(),
      getAmazonSellerAccountsWrapper(),
    ]);
    setLoading(false);
  }

  useEffect(() => {
    getAccountData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <React.Fragment>
      <LoadingBackdrop open={loading} />
      {user && company && bankAccounts && plaidLinkToken && (
        <React.Fragment>
          <Header header="Account" />
          <PageContent>
            <SubHeader
              text={is8DataApp() ? HEADER_8DATA : HEADER_8FIG}
              extraClasses={classes.centerizedContent}
            />
            <Layout
              user={user}
              company={company}
              bankAccounts={bankAccounts}
              setBankAccounts={setBankAccounts}
              amzAccounts={amzAccounts}
              plaidLinkToken={plaidLinkToken}
              setLoading={setLoading}
              containerClass={classes.centerizedContent}
            />
          </PageContent>
        </React.Fragment>
      )}
    </React.Fragment>
  );
}
